/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import Question from '../animations/question';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

/**
 *
 */
EDC.Games.LettersAlphabetical.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.LettersAlphabetical, 8]);

  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.difficulty = 1;
  this.iteration = 0;
  this.initialLetters = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ];
  this.sequenceAscending = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ];
  this.sequenceDescending = [
    'Z',
    'Y',
    'X',
    'W',
    'V',
    'U',
    'T',
    'S',
    'R',
    'Q',
    'P',
    'O',
    'N',
    'M',
    'L',
    'K',
    'J',
    'I',
    'H',
    'G',
    'F',
    'E',
    'D',
    'C',
    'B',
    'A',
  ];
  this.targetSequence = '';
  this.currentSequence = '';
  this.currentIndex = 0;
  this.currentLetter = '';
  this.completedLetters = [];
  this.taskLetters = [];
  this.monsters = [];
  this.question = null;
  this.optionsWidth = 1500;
};
/**
 *
 */
EDC.Games.LettersAlphabetical.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.LettersAlphabetical.Scenes.Main.prototype.constructor = EDC.Games.LettersAlphabetical.Scenes.Main;
/**
 *
 */
EDC.Games.LettersAlphabetical.Scenes.Main.prototype.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

EDC.Games.LettersAlphabetical.Scenes.Main.prototype.loadIteration = function () {
  this.setSequence();
  this.startLetter();
  this.addMonsters();
};

EDC.Games.LettersAlphabetical.Scenes.Main.prototype.createAnimations = function () {
  const animsCfg = {
    'question-blinking': {
      key: 'question-blinking',
      frames: this.anims.generateFrameNumbers('question-mark', { start: 0, end: 2, first: 0 }),
      frameRate: 3,
      repeat: -1,
    },
  };

  Object.entries(animsCfg).forEach(([key]) => {
    const cfg = animsCfg[key];
    this.anims.create(cfg);
  });
};

EDC.Games.LettersAlphabetical.Scenes.Main.prototype.createTemplateUI = function () {
  this.createAnimations();

  this.add.sprite(this.game.config.width / 2, 1030, 'label-title');

  this.question = new Question(this);
  this.question.create(50, 50);
};

EDC.Games.LettersAlphabetical.Scenes.Main.prototype.getRandomValueFromArray = function (targetArray) {
  const rndIdx = Math.floor(Math.random() * targetArray.length);
  const res = targetArray.splice(rndIdx, 1);
  return res[0];
};
/**
 *
 */
EDC.Games.LettersAlphabetical.Scenes.Main.prototype.addMonsters = function () {
  for (let i = 0; i < this.monsters.length; i++) {
    this.monsters[i].destroy();
  }
  this.monsters = [];

  const possibleIndexes = [];
  for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].optionsCount; i++) {
    possibleIndexes.push(i);
  }

  const sx = (this.game.config.width - this.optionsWidth) / 2;
  const slotWidth = this.optionsWidth / this.gameConfig.sets[this.difficulty].iterations[this.iteration].optionsCount;

  for (
    let optionIndex = 0;
    optionIndex < this.gameConfig.sets[this.difficulty].iterations[this.iteration].optionsCount;
    optionIndex++
  ) {
    const index = this.getRandomValueFromArray(possibleIndexes);

    const x = sx + slotWidth * optionIndex + slotWidth / 2;
    const monsterSprite = this.add.sprite(x, 770, `monster-${index}`);
    this.monsters.push(monsterSprite);
  }
};
/**
 *
 */
EDC.Games.LettersAlphabetical.Scenes.Main.prototype.setSequence = function () {
  const iteration = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  this.targetSequence = iteration.ASCENDING === true ? this.sequenceAscending : this.sequenceDescending;
  this.currentIndex = 0;
  this.currentLetter = this.targetSequence[this.currentIndex];
  this.currentSequence = '';
  for (let i = 0; i < this.completedLetters.length; i++) {
    this.completedLetters[i].destroy();
  }
  this.completedLetters = [];
};
/**
 *
 */
EDC.Games.LettersAlphabetical.Scenes.Main.prototype.addTaskLetters = function (values) {
  for (let i = 0; i < this.taskLetters.length; i++) {
    this.taskLetters[i].destroy();
  }
  this.taskLetters = [];

  const sx = (this.game.config.width - this.optionsWidth) / 2;
  const slotWidth = this.optionsWidth / this.gameConfig.sets[this.difficulty].iterations[this.iteration].optionsCount;

  for (let i = 0; i < values.length; i++) {
    const x = sx + slotWidth * i + slotWidth / 2;
    const startX = this.game.config.width + x;
    const container = this.add.container(startX, 400);
    const letterSprite = this.add.sprite(0, 0, `${values[i]}-big`);

    container.setSize(letterSprite.width, letterSprite.height);
    container.setData('isCorrect', values[i] === this.currentLetter);
    container.setData('isActive', false);
    container.setData('placeX', x);
    container.setInteractive();

    container.add(letterSprite);
    const markAnim = new AnswerMark(this, container).setScale(0.45);
    container.setData('markAnim', markAnim);

    container.on('pointerup', this.letterClick.bind(this, container));

    this.cursorManager.setDefaultDraggableEvents(container);

    const randomDistance = 15 + Math.round(Math.random() * 10);
    const randomDelay = Math.round(Math.random() * 1000);

    const floatingTween = this.tweens.add({
      targets: container,
      y: container.y - randomDistance,
      duration: 1200,
      delay: randomDelay,
      ease: 'Sine.easeInOut',
      yoyo: true,
      repeat: -1,
    });
    container.setData('floatingTween', floatingTween);

    this.taskLetters.push(container);
  }

  for (let i = 0; i < this.taskLetters.length; i++) {
    this.tweens.add({
      targets: this.taskLetters[i],
      x: this.taskLetters[i].getData('placeX'),
      duration: 700,
      ease: 'Back.easeOut',
      onComplete: function (letter) {
        letter.setData('isActive', true);
      }.bind(this, this.taskLetters[i]),
    });
  }
};
/**
 *
 */
EDC.Games.LettersAlphabetical.Scenes.Main.prototype.letterClick = function (target) {
  if (target.getData('isCorrect')) {
    for (let i = 0; i < this.taskLetters.length; i++) {
      this.taskLetters[i].removeInteractive();
    }
  } else {
    target.removeInteractive();
  }

  if (!target.getData('isActive')) return;

  this.tweens.add({
    targets: target,
    scaleX: 0.9,
    scaleY: 0.9,
    duration: 100,
    ease: 'Linear',
    yoyo: true,
    onComplete: this.checkAnswer.bind(this, target),
  });
};
/**
 *
 */
EDC.Games.LettersAlphabetical.Scenes.Main.prototype.checkAnswer = function (target) {
  if (target.getData('isCorrect')) {
    target.getData('markAnim').showMark(true, this.completeLetter.bind(this, target));
    this.playCorrect();
  } else if (target.getData('isActive')) {
    target.setData('isActive', false);
    target.getAt(0).setTint(0xff0000);
    target.getData('markAnim').showMark(false, () => {});
    this.playWrong();
  }
};
/**
 *
 */
EDC.Games.LettersAlphabetical.Scenes.Main.prototype.startLetter = function () {
  const generatedLetters = [];
  const tmpSequence = this.initialLetters.map(element => element);

  // remove current letter to be sure it not duplicate
  const ci = tmpSequence.indexOf(this.currentLetter);
  if (ci >= 0) {
    tmpSequence.splice(ci, 1);
  }

  for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].optionsCount; i++) {
    const rndLetter = this.getRandomValueFromArray(tmpSequence);
    generatedLetters.push(rndLetter);
  }
  const rndIdx = Math.floor(Math.random() * generatedLetters.length);
  generatedLetters[rndIdx] = this.currentLetter;
  this.addTaskLetters(generatedLetters);
  // this.addMonsters();
};
/**
 *
 */
EDC.Games.LettersAlphabetical.Scenes.Main.prototype.completeLetter = function (target) {
  if (this.currentIndex >= this.targetSequence.length) return;

  const pos = this.placeCompletedLetterToSequence();

  const floatTween = target.getData('floatingTween');
  if (floatTween) {
    floatTween.stop();
  }

  this.tweens.add({
    targets: target,
    x: pos.x,
    y: pos.y,
    scaleX: 0.44,
    scaleY: 0.44,
    duration: 800,
    ease: 'Linear',
    onComplete: function () {
      target.setAlpha(0);
      this.completedLetters[this.completedLetters.length - 1].setAlpha(1);
      this.taskLettersDisappear(this.nextIteration.bind(this));
    }.bind(this),
  });
};
/**
 *
 */
EDC.Games.LettersAlphabetical.Scenes.Main.prototype.placeCompletedLetterToSequence = function () {
  const sx = 50;
  const sy = 50;
  const smallLetterSprite = this.add.sprite(sx, sy, `${this.currentLetter}-small`);
  if (this.completedLetters.length) {
    const prev = this.completedLetters[this.completedLetters.length - 1];
    const x = prev.x + prev.width / 2 + smallLetterSprite.width / 2;
    smallLetterSprite.setPosition(x, sy);
  }
  this.completedLetters.push(smallLetterSprite);
  this.question.moveTo(smallLetterSprite.x + smallLetterSprite.width / 2, smallLetterSprite.y);
  smallLetterSprite.setAlpha(0);

  return {
    x: smallLetterSprite.x,
    y: smallLetterSprite.y,
  };
};
/**
 *
 */
EDC.Games.LettersAlphabetical.Scenes.Main.prototype.nextIteration = function () {
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.currentIndex = this.currentIndex + 1;
    this.currentLetter = this.targetSequence[this.currentIndex];
    this.loadIteration();
  }
};
/**
 *
 */
EDC.Games.LettersAlphabetical.Scenes.Main.prototype.taskLettersDisappear = function (completeCallback) {
  for (let i = 0; i < this.taskLetters.length; i++) {
    this.tweens.add({
      targets: this.taskLetters[i],
      alpha: 0,
      ease: 'Linear',
      duration: 500,
      onComplete: function (callback, index, length) {
        if (index === length) {
          callback();
        }
      }.bind(this, completeCallback, i, this.taskLetters.length - 1),
    });
  }
};

export default EDC.Games.LettersAlphabetical.Scenes.Main;
